import { PropsWithChildren, ReactElement, useCallback, useRef } from 'react';
import { isPlatform } from '@ionic/react';

import {
  ActionSheetMenuPopover,
  ActionSheetMenuPopoverPlacement,
} from './ActionSheetMenuPopover';
import { ActionSheetMenuItem } from './ActionSheetMenuItem/ActionSheetMenuItem';
import { ActionSheetMenuModal } from './ActionSheetMenuModal/ActionSheetMenuModal';
import { ActionSheetMenuButton } from './ActionSheetMenuButton/ActionSheetMenuButton';
import { ActionSheetMenuCta } from './ActionSheetMenuCta/ActionSheetMenuCta';
import { ActionSheetMenuContext } from './ActionSheetMenu.context';

type ActionSheetMenuProps = PropsWithChildren<{
  width?: number;
  placement?: ActionSheetMenuPopoverPlacement;
}>;

interface ActionSheetMenuComponent {
  (props: ActionSheetMenuProps): ReactElement;
  Item: typeof ActionSheetMenuItem;
  Button: typeof ActionSheetMenuButton;
  Cta: typeof ActionSheetMenuCta;
}

export const ActionSheetMenu: ActionSheetMenuComponent = ({
  width,
  children,
  placement,
}) => {
  const popover = useRef<HTMLIonPopoverElement>();
  const modal = useRef<HTMLIonModalElement>();

  const isDesktop = isPlatform('desktop');

  const dismiss = useCallback(() => {
    popover?.current?.dismiss();
    modal?.current?.dismiss();
  }, []);

  return (
    <ActionSheetMenuContext.Provider value={{ dismiss, width }}>
      {isDesktop ? (
        <ActionSheetMenuPopover placement={placement} ref={popover}>
          {children}
        </ActionSheetMenuPopover>
      ) : (
        <ActionSheetMenuModal ref={modal}>{children}</ActionSheetMenuModal>
      )}
    </ActionSheetMenuContext.Provider>
  );
};

ActionSheetMenu.Item = ActionSheetMenuItem;
ActionSheetMenu.Button = ActionSheetMenuButton;
ActionSheetMenu.Cta = ActionSheetMenuCta;
